import React, { useState, useEffect } from "react";
import "./intro.css";
import Me from "../../img/me.png";
import {
  trackCvDownload,
  trackNavClick,
  trackSocialClick,
  trackDirectContact,
} from "../../utils/analytics";

const Intro = ({ darkMode }) => {
  const roles = ["Frontend Developer", "React.js Specialist", "Enterprise App Builder"];
  const [roleIndex, setRoleIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setRoleIndex((prev) => (prev + 1) % roles.length);
        setFade(true);
      }, 500); // Half second fade-out before switching text
    }, 3500);
    return () => clearInterval(interval);
  }, [roles.length]);

  const scrollToSection = (id) => {
    trackNavClick(id, "hero_view_my_work");
    const el = document.getElementById(id);
    if (el) {
      window.scrollTo({
        top: el.offsetTop - 70,
        behavior: "smooth"
      });
    }
  };

  const experienceYears = new Date().getFullYear() - 2021;

  return (
    <div className="intro-section">
      <div className="intro-container">
        <div className="intro-left">
          <div className="intro-left-wrapper">
            <h2 className="intro-greeting">Hello, My name is</h2>
            <h1 className="intro-name">Sezgin Akgül</h1>
            <div className="intro-title-container">
              <span className={`intro-title-text ${fade ? "fade-in" : "fade-out"}`}>
                {roles[roleIndex]}
              </span>
            </div>
            <p className="intro-desc">
              Frontend Developer with {experienceYears}+ years of specialized experience in designing and deploying scalable,
              high-performance web applications using React.js, TypeScript, and modern ecosystem tools.
              Focused on building component-based architectures that bridge beautiful interfaces with robust,
              clean engineering.
            </p>

            <div className="intro-actions">
              <button onClick={() => scrollToSection("projects")} className="btn-primary">
                View My Work <i className="fa-solid fa-arrow-right"></i>
              </button>
              <a
                href="/Sezgin-Akgül.pdf"
                download="Sezgin-Akgül.pdf"
                className="btn-secondary"
                onClick={() => trackCvDownload("Sezgin-Akgül.pdf")}
              >
                Download CV <i className="fa-solid fa-download"></i>
              </a>
            </div>

            <div className="intro-socials">
              <a
                href="https://www.linkedin.com/in/sezginakgul/"
                target="_blank"
                rel="noreferrer"
                title="LinkedIn"
                onClick={() =>
                  trackSocialClick("LinkedIn", "https://www.linkedin.com/in/sezginakgul/")
                }
              >
                <i className="fa-brands fa-linkedin"></i>
              </a>
              <a
                href="https://github.com/sezginakgul"
                target="_blank"
                rel="noreferrer"
                title="GitHub"
                onClick={() =>
                  trackSocialClick("GitHub", "https://github.com/sezginakgul")
                }
              >
                <i className="fa-brands fa-square-github"></i>
              </a>
              <a
                href="https://wa.me/+905346158014"
                target="_blank"
                rel="noreferrer"
                title="WhatsApp"
                onClick={() => {
                  trackSocialClick("WhatsApp", "https://wa.me/+905346158014");
                  trackDirectContact("whatsapp", "+905346158014");
                }}
              >
                <i className="fa-brands fa-square-whatsapp"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="intro-right">
          <div className="intro-image-frame glass-panel">
            <div className="intro-gradient-glow"></div>
            <img src={Me} alt="Sezgin Akgül" className="intro-profile-img" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Intro;
